import React from 'react';
import {motion} from 'framer-motion';
import {useLanguage} from '../context/LanguageContext';

// Component to display COSMO heads with different clinical attention levels
const CosmoHeads = ({attentionLevel, size='medium', showLabel=true, animate=true}) => {
  const {t} = useLanguage();
  
  // Define sizes based on the size parameter
  const sizes = {
    small: "w-10 h-10",
    medium: "w-16 h-16",
    large: "w-24 h-24"
  };
  
  // Define colors and labels based on attention level
  const levelConfig = {
    normal: {
      image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753548491382-normal.png",
      bgColor: "bg-green-100",
      borderColor: "border-green-500",
      textColor: "text-green-700",
      label: t('normalAttention')
    },
    attention: {
      image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753548892995-attention.png",
      bgColor: "bg-yellow-100",
      borderColor: "border-yellow-500",
      textColor: "text-yellow-700",
      label: t('clinicalAttention')
    },
    highAttention: {
      image: "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1753549240715-high.png",
      bgColor: "bg-red-100",
      borderColor: "border-red-500",
      textColor: "text-red-700",
      label: t('highClinicalAttention')
    }
  };
  
  const config = levelConfig[attentionLevel] || levelConfig.normal;
  
  // Pulse animation for high attention situations
  const pulseAnimation = animate && attentionLevel === 'highAttention' ? {
    scale: [1, 1.05, 1],
    transition: {repeat: Infinity, duration: 2}
  } : {};
  
  return (
    <div className="flex flex-col items-center">
      <motion.div 
        className={`${sizes[size]} rounded-full ${config.bgColor} border-2 ${config.borderColor} flex items-center justify-center overflow-hidden`}
        animate={pulseAnimation}
      >
        <img 
          src={config.image} 
          alt={`COSMO - ${config.label}`} 
          className="w-full h-full object-cover"
        />
      </motion.div>
      
      {showLabel && (
        <span className={`mt-2 text-sm font-medium ${config.textColor}`}>
          {config.label}
        </span>
      )}
    </div>
  );
};

export default CosmoHeads;